import { useStore as t } from "@nanostores/react";
import { useState as l, useCallback as a, useEffect as f } from "react";
import { CopilotSession as n } from "../session.js";
import { currentCopilotSession as r } from "../global-state.js";
function S(e) {
  const [s, i] = l(() => new n()), u = a(() => {
    const o = new n();
    return i(o), o;
  }, []);
  return f(() => {
    e?.isPrimary && r.set(s);
  }, [s, e?.isPrimary]), s.reset == null && Object.assign(s, { reset: u }), s;
}
function _() {
  return t(r);
}
function b(e) {
  return t(e.__status);
}
function g(e) {
  return t(e.__statefulMessages);
}
function w(e) {
  return t(e.__tools);
}
function y(e) {
  return t(e.__meta);
}
export {
  w as useCopilotAvailableTools,
  g as useCopilotMessages,
  y as useCopilotMeta,
  S as useCopilotSession,
  b as useCopilotStatus,
  _ as usePrimaryCopilotSession
};
